export default "__VITE_ASSET__9c3862c3__"